import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import flatpickr from 'flatpickr';
import { Subscription } from 'rxjs';
import { icons } from 'src/assets/images/icons';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements AfterViewInit, OnDestroy {
  public iconPack = icons;

  @ViewChild('timeInput') timeInput!: ElementRef;

  @Input() control: FormControl = new FormControl();
  @Input() class?: string | null = null;
  @Input() label?: string | null = null;
  @Input() requiredText?: string | null = null;
  @Input() placeholder?: string | null = null;

  flatpickrInstance: any;
  controlSubscription!: Subscription;

  constructor(
    private zone: NgZone,
    private cdr: ChangeDetectorRef
  ){}

  ngAfterViewInit(): void {
    if (this.timeInput?.nativeElement) {
      this.initializeFlatpickr();
    }
    const element = document.querySelector('#element');
    element?.addEventListener('keydown', function(e: any) {
      console.log("Typing detected:", e.target?.value);
    });
  }


  initializeFlatpickr(): void {
    if (!this.timeInput?.nativeElement) return; // Safety check

    const now = this.control.value !== null ? this.convertTimeStringToDate(this.control.value) : new Date();
    if(this.control.value === null) {
      now.setHours(12, 0, 0, 0);
    }

    this.flatpickrInstance = flatpickr(this.timeInput.nativeElement, {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      altInput: true,
      altFormat: "h:i K",
      time_24hr: true,
      inline: true,
      defaultDate: now,
      disableMobile: true,
      onReady: (selectedDates, dateStr, instance) => {
        (instance.altInput as HTMLInputElement).placeholder = this.placeholder || 'Select Time';
        if(this.control.value === null) {
          const formattedTime = instance.formatDate(now, "H:i");
          this.zone.run(() => {
            this.control.setValue(formattedTime);
            this.cdr.detectChanges();
          });
        }
      },
      onValueUpdate: (selectedDates: Date[], dateStr, instance) => {
        this.handleChange(selectedDates, dateStr, instance)
      },
      onChange: (selectedDates: Date[], dateStr, instance) => {
        this.handleChange(selectedDates, dateStr, instance)
      },
      onClose: (selectedDates: Date[], dateStr, instance) => {
        this.handleChange(selectedDates, dateStr, instance)
        this.control.markAsDirty();
        this.control.markAsTouched();
      }
    });
    this.cdr.markForCheck();
  }

  handleChange = (selectedDates: Date[], dateStr: any, instance: any) => {
    if (selectedDates.length > 0) {
      const formattedTime = instance.formatDate(selectedDates[0], "H:i");
      this.zone.run(() => {
        instance.set
        this.control.setValue(formattedTime);
        this.cdr.detectChanges();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
    if (this.controlSubscription) {
      this.controlSubscription.unsubscribe();
    }
  }

  onClearTime(): void {
    // Create a date object set to today at 12:00
    const defaultTime = new Date();
    defaultTime.setHours(12, 0, 0, 0);
    
    // Set the flatpickr instance to 12:00
    this.flatpickrInstance.setDate(defaultTime);
    
    // Update the form control
    this.control.setValue("12:00");
  }

  private convertTimeStringToDate(timeStr: any): Date {
    // If it's already a Date, return it.
    if (timeStr instanceof Date) {
      return timeStr;
    }
    // If it's not a string, return current date.
    if (typeof timeStr !== 'string') {
      return new Date();
    }
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

}
